export interface Ferramenta {
  id: number;
  img: string;
  link: string;
  nome: string;
}

export interface AnosFerramentas {
  anoKey: string;
  ferramentas: Ferramenta[];
}

export const ferramentasB2B: AnosFerramentas[] = [
  {
    anoKey: 'fund1',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/stem-play.png',
        link: 'https://app.stemplay.io/',
        nome: 'STEM Play',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/scratchjr.png',
        link: 'https://codejr.org/scratchjr/index.html',
        nome: 'Scratchjr',
      },
    ],
  },
  {
    anoKey: 'fund2',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/stem-play.png',
        link: 'https://app.stemplay.io/',
        nome: 'STEM Play',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/kahoot.png',
        link: 'https://kahoot.it/',
        nome: 'Kahoot',
      },
      {
        id: 3,
        img: './assets/img/ferramentas-b2b/google-earth.png',
        link: 'https://earth.google.com/web/',
        nome: 'Google Earth',
      },
    ],
  },
  {
    anoKey: 'fund3',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/stem-play.png',
        link: 'https://app.stemplay.io/',
        nome: 'STEM Play',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/kahoot.png',
        link: 'https://kahoot.it/',
        nome: 'Kahoot',
      },
    ],
  },
  {
    anoKey: 'fund4',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/stem-play.png',
        link: 'https://app.stemplay.io/',
        nome: 'STEM Play',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/scratch.png',
        link: 'https://scratch.mit.edu/',
        nome: 'Scratch',
      },
      {
        id: 3,
        img: './assets/img/ferramentas-b2b/microbit.png',
        link: 'https://microbit.org/',
        nome: 'Micro:Bit',
      },
    ],
  },
  {
    anoKey: 'fund5',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/scratch.png',
        link: 'https://scratch.mit.edu/',
        nome: 'Scratch',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/kahoot.png',
        link: 'https://kahoot.it/',
        nome: 'Kahoot',
      },
    ],
  },
  {
    anoKey: 'fund6',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/construct3.png',
        link: 'https://editor.construct.net/',
        nome: 'Construct 3',
      },
    ],
  },
  {
    anoKey: 'fund7',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/tinkercad.png',
        link: 'https://www.tinkercad.com/',
        nome: 'Tinkercad',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/construct3.png',
        link: 'https://editor.construct.net/',
        nome: 'Construct 3',
      },
    ],
  },
  {
    anoKey: 'fund8',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/figma.png',
        link: 'https://www.figma.com/',
        nome: 'Figma',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/canva.png',
        link: 'https://www.canva.com/',
        nome: 'Canva',
      },
      {
        id: 3,
        img: './assets/img/ferramentas-b2b/glide.png',
        link: 'https://www.glideapps.com/',
        nome: 'Glide',
      },
    ],
  },
  {
    anoKey: 'fund9',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/quickdraw.png',
        link: 'https://quickdraw.withgoogle.com/',
        nome: 'Quickdraw',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/chat-gpt.png',
        link: 'https://chat.openai.com/',
        nome: 'ChatGPT',
      },
      {
        id: 3,
        img: './assets/img/ferramentas-b2b/charater.png',
        link: 'https://character.ai/',
        nome: 'Character',
      },
      {
        id: 4,
        img: './assets/img/ferramentas-b2b/thunkable.png',
        link: 'https://x.thunkable.com/projects',
        nome: 'Thunkable',
      },
      {
        id: 5,
        img: './assets/img/ferramentas-b2b/glide.png',
        link: 'https://www.glideapps.com/',
        nome: 'Glide',
      },
    ],
  },
  {
    anoKey: 'em1',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/construct3.png',
        link: 'https://editor.construct.net/',
        nome: 'Construct 3',
      },
    ],
  },
  {
    anoKey: 'em2',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/construct3.png',
        link: 'https://editor.construct.net/',
        nome: 'Construct 3',
      },
    ],
  },
  {
    anoKey: 'em3',
    ferramentas: [
      {
        id: 1,
        img: './assets/img/ferramentas-b2b/thunkable.png',
        link: 'https://x.thunkable.com/projects',
        nome: 'Thunkable',
      },
      {
        id: 2,
        img: './assets/img/ferramentas-b2b/glide.png',
        link: 'https://www.glideapps.com/',
        nome: 'Glide',
      },
    ],
  },
];
